import { Flex } from '@chakra-ui/react';
import { UpArrow } from "@root/assets/admin/icons/upArrow";
import { LeftArrow } from '@root/assets/icons/leftArrow';
import { CustomText } from '@root/components/common/components';
import { CenterFlex, CenterFlexGap } from '@root/components/dashboard/chat/style';
import { useTranslation } from 'react-i18next';
import { NormalHeading } from "./style";


export const RevenueText = ({ text, hideArrow, parentBg, color = 'theme.success.100', rotate = false, ...props }: any) => (
    <CenterFlex
        bgColor={parentBg || 'rgba(64, 220, 145, 0.2)'}
        borderRadius={'4px'}
        padding={'2px 4px'}
        maxH={'21px'}
        userSelect={'none'}
    >
        <CustomText
            text={text}
            color={color}
            {...props}
        />
        {
            !hideArrow && (
                <UpArrow color={color} transform={rotate ? 'rotate(180deg)' : 'rotate(0deg)'} />
            )
        }
    </CenterFlex>
)

export const AllTransactions = ({ clickOnAll }: any) => {
    const { t } = useTranslation('common');
    return (
        <Flex
            justifyContent={'space-between'}
            alignItems={'center'}
            minH={'37px'}
        >
            <NormalHeading
                text={t('allTransactions.pendingTransaction')}
            />
            <CenterFlexGap
                gap={'10px'}
                cursor={'pointer'}
                userSelect={'none'}
                onClick={clickOnAll}
            >
                <CustomText
                    type='primary'
                    fontSize={'12px'}
                    fontWeight={700}
                    text={t('allTransactions.seeAll')}
                />
                <LeftArrow
                    width={'10px'}
                    height={'10.5px'}
                    color={'theme.button.primary'}
                    transform={'rotate(180deg)'}
                />
            </CenterFlexGap>
        </Flex>
    )
}

export const IgnoreAll = ({ translate, onIgnoreAll }: any) => (
    <Flex
        justifyContent={'space-between'}
        alignItems={'center'}
        h={'37px'}
    >
        <NormalHeading
            text={translate("adminOverview.activityArea")}
        />
        <CenterFlexGap
            gap={'10px'}
            cursor={'pointer'}
            userSelect={'none'}
        >
            <CustomText
                type='primary'
                fontSize={'14px'}
                fontWeight={700}
                onClick={onIgnoreAll}
                text={translate("adminOverview.ignoreAll")}
            />
        </CenterFlexGap>
    </Flex>
)


